import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentReview() {
  return (
    <FulfillmentQueue
      title="Review"
      statusFilter="review"
      emptyMessage="No orders awaiting review"
    />
  );
}
